import React from "react"
import PropTypes from "prop-types"

import css from "./Price.scss"

const Price = ({ price, discount, discountedPrice, variantSmall }) => {
    return (
        <div className="flex alignBaseline">
            <span className={`textPrimary ${variantSmall ? "l5Medium" : "l4Medium"}`}>
                {!discountedPrice ? (
                    <>
                        <span className="visuallyHidden">Original Price: </span>
                        {price}
                    </>
                ) : (
                    <>
                        <span className="visuallyHidden">Discounted Price: </span>
                        {discountedPrice}
                    </>
                )}
            </span>
            {discount && (
                <>
                    <strike
                        className={`${variantSmall ? "smallRegular" : "bodyRegular"} ${
                            css.marginLeft4
                        } textTertiary`}
                    >
                        <span className="visuallyHidden">Original Price: </span>
                        {`${price}`}
                    </strike>
                    {discount && (
                        <span
                            className={`successColor ${variantSmall ? "smallMedium" : "bodyMedium"} ${
                                css.marginLeft4
                            }`}
                        >
                            <span className="visuallyHidden">Discount Percentage: </span>
                            {discount}
                        </span>
                    )}
                </>
            )}
        </div>
    )
}

Price.propTypes = {
    price: PropTypes.string.isRequired,
    discount: PropTypes.string,
    discountedPrice: PropTypes.string,
    variantSmall: PropTypes.bool,
}

Price.defaultProps = {
    variantSmall: false,
}

export default Price
